// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"48":"d929c01e","208":"ae26a139","295":"a172e73e","447":"ccb641e6","574":"87c511f5","640":"c86bc5cd","702":"5cd167f6","860":"f67eff92","999":"e4f4f4a8"}[chunkId] + ".js";
};